import { Badge, Tooltip } from '@chakra-ui/react';
import { EventType } from 'src/gql/graphql';

type DiffBadgeProps = {
  eventType: EventType;
};

export function DiffBadge({ eventType }: DiffBadgeProps) {
  let colorScheme = 'orange';
  let label = '~';

  switch (eventType) {
    case EventType.Created:
      colorScheme = 'green';
      label = '+';
      break;
    case EventType.Deleted:
      colorScheme = 'red';
      label = '-';
      break;
    case EventType.Modified:
      colorScheme = 'orange';
      label = '~';
      break;
  }

  return (
    <Tooltip label={eventType}>
      <Badge
        colorScheme={colorScheme}
        textTransform={'none'}
        fontSize={'md'}
        borderRadius={'md'}
        fontWeight={'bold'}
        paddingX={2}
        lineHeight={1}
        width={6}
      >
        {label}
      </Badge>
    </Tooltip>
  );
}
